export default __webpack_public_path__ + "static/media/failed-payment.6cec04e6.png";